module.exports = __webpack_public_path__ + "static/certificate2-dfee90c2d6ab3110b920acd548e86dff.pdf";